import { ArrowUpRight } from "lucide-react";
import { FOOTER, NAV, SERVER, ASSETS } from "@/data/content";
import { Reveal } from "./Reveal";

export const Footer = () => (
  <footer className="relative border-t border-white/[0.06] bg-[#0a0a0b]" data-testid="footer">
    <div className="mx-auto max-w-[1400px] px-5 pb-10 pt-16 sm:px-8 sm:pt-20">
      <div className="grid grid-cols-1 gap-12 md:grid-cols-12">
        <Reveal className="md:col-span-5">
          <div className="flex items-center gap-4">
            <img src={ASSETS.logo} alt="Barren County Roleplay logó" className="h-12 w-12 object-contain" />
            <div>
              <p className="font-display text-base font-bold uppercase tracking-[0.12em] text-white">{SERVER.name}</p>
              <p className="font-mono text-xs text-white/40">{SERVER.ip}</p>
            </div>
          </div>
        </Reveal>
        <Reveal delay={0.1} className="md:col-span-3">
          <p className="eyebrow mb-5">Menü</p>
          <ul className="space-y-3">
            {[...NAV, { label: "Csatlakozás", href: SERVER.mtaLink }].map((n) => (
              <li key={n.label}>
                <a
                  href={n.href}
                  target={n.external ? "_blank" : undefined}
                  rel={n.external ? "noreferrer" : undefined}
                  className="link-underline inline-flex items-center gap-1 text-sm text-white/60 transition-colors hover:text-white"
                  data-testid={`footer-link-${n.label.toLowerCase().replace(/\s+/g, '-')}`}
                >
                  {n.label}
                  {n.external && <ArrowUpRight size={12} className="opacity-50" />}
                </a>
              </li>
            ))}
          </ul>
        </Reveal>
        <Reveal delay={0.2} className="md:col-span-4">
          <p className="eyebrow mb-5">Közösség</p>
          <ul className="space-y-3">
            <li>
              <a href={SERVER.discord} target="_blank" rel="noreferrer" className="link-underline text-sm text-white/60 transition-colors hover:text-white" data-testid="footer-discord-link">
                discord.gg/HGJXNNcqfh
              </a>
            </li>
            <li>
              <a href={SERVER.forum} className="link-underline text-sm text-white/60 transition-colors hover:text-white" data-testid="footer-forum-link">
                bc-rp.hu/forum
              </a>
            </li>
            <li>
              <a href={SERVER.site} target="_blank" rel="noreferrer" className="link-underline text-sm text-white/60 transition-colors hover:text-white" data-testid="footer-site-link">
                bc-rp.hu
              </a>
            </li>
          </ul>
        </Reveal>
      </div>

      <div className="mt-16 flex flex-col gap-2 border-t border-white/[0.06] pt-6 text-xs text-white/40 sm:flex-row sm:items-center sm:justify-between">
        <p data-testid="footer-copyright">{FOOTER.copyright}</p>
        <p data-testid="footer-credit">{FOOTER.credit}</p>
      </div>
    </div>
    <div className="pointer-events-none select-none overflow-hidden">
      <p className="font-display text-stroke whitespace-nowrap text-center text-[12vw] font-bold uppercase leading-none tracking-tight opacity-[0.18]">
        Barren County
      </p>
    </div>
  </footer>
);
